import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-image-link',
  templateUrl: './image-link.component.html',
  styleUrls: ['./image-link.component.scss']
})
export class ImageLinkComponent {
  @Input() href: string;
  @Input() src: string;

  goToLink() {
    window.location.href = this.href;
  }
}
